import { render } from "./SliderCreatePage.vue?vue&type=template&id=270f10ae"
import script from "./SliderCreatePage.vue?vue&type=script&lang=js"
export * from "./SliderCreatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__